// src/redux/thunks/certConnectThunks.ts
import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../api/api";
import { ContactDesingationResponse } from "../../types/contactDesignations";
import { AllDesignationsResponse } from "../../types/allcertificationdesignations";



export const getContactDesignations = createAsyncThunk<
  ContactDesingationResponse,          
  string | number,           
  { rejectValue: string }    
>(
  "designation/getContactDesignations",
  async (ContactId, { rejectWithValue }) => {
    try {
      const response = await api.get(`certWatch/contact-designations?Id=${ContactId}`);

      if (response.data) {
        return response.data as ContactDesingationResponse;
      } else {
        console.error(response.data.message);
        return rejectWithValue(response.data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);


export const getActiveDesignations = createAsyncThunk<
  AllDesignationsResponse,          
  void,           
  { rejectValue: string }    
>(
  "designation/activeDesignations",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`certWatch/active-designations`);

      if (response.data) {
        return response.data as AllDesignationsResponse;
      } else {
        console.error(response.data.message);
        return rejectWithValue(response.data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
